import { RefObject, useEffect, useRef } from 'react';

import { APP_BOTTOM_BAR_HEIGHT_PROPERTY } from './BottomBar.constants';

export function usePublishBottomBarHeight(): RefObject<HTMLElement | null> {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return undefined;
    }

    const rootStyle = document.documentElement.style;
    const observer = new ResizeObserver(() => {
      rootStyle.setProperty(
        APP_BOTTOM_BAR_HEIGHT_PROPERTY,
        `${element.getBoundingClientRect().height}px`,
      );
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
      rootStyle.removeProperty(APP_BOTTOM_BAR_HEIGHT_PROPERTY);
    };
  }, []);

  return ref;
}
